import React, { useEffect, useState } from "react";
import { getDirectusClient } from "../../../lib/directus";
import { Button, Form, Input, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { readItems } from "@directus/sdk";
import { useSelector } from "react-redux";

function Grupo(props) {
  const arrayp = props.productosagregados;
  const [seriales, setSeriales] = useState([]);

  const [productos, setProductos] = useState([]);
  const [form] = useForm();
 const userBodega = useSelector((state) => state.userdata.bodega);
  const onFinish = async (values) => {
    const directus = await getDirectusClient();
    try {
      const response = await directus.request(
        readItems('seriales', {
          fields: [
            "*",
            "producto.preciosinimp",
            "producto.nombre",
            "producto.id",
            "producto.grupo.*",
          ],
          filter: { 
            caja: values.caja,
            grupo: values.grupo,
            estado: 1,
            bodega: userBodega.id // Add filter for user's bodega
          },
          limit: -1,
        })
      );
      if (response.length <= 0) {
        Modal.error({
          title: "No se encontraron seriales con los datos suministrados",
        });
      }
      setSeriales(response);
   
      props.setProductosagregados(response);
    } catch (error) {
      console.error('Error:', error);
    }
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {}, [arrayp]);

  return (
    <>
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Space size="large" direction="vertical" style={{ display: "flex" }}>
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            label="Caja"
            name="caja"
            rules={[{ required: true, message: "Please input your caja!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{ offset: 8, span: 16 }}
            label="Grupo"
            name="grupo"
            rules={[{ required: true, message: "Please input your caja!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              procesar
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </>
  );
}

export default Grupo;
